import {fetchRequestSend} from "../../helpers/common-helpers";

export default class HubspotIntegrationClass {

    /*
    * Sending form to hubspot based on form id attribute value
     */
    sendForm(form) {
        console.log(form)
        let form_id = form.getAttribute('id');
        let formdata = new FormData(form);
        console.log(form_id)
        switch (form_id) {
            case 'contact-form':
                this.sendContactForm(formdata);
                break;
            case 'qr-webform':
                this.sendQuickReferenceForm(formdata);
                break;
            case 'get-quote':
                this.sendGetQuoteForm(formdata);
                break;
            default:
                break;
        }
        return true;
    }

    /*
    * Sending quick reference form to hubspot
    * */
    async sendQuickReferenceForm(fields) {
        // Map topic names to hubspot topic names because some of them is different
        const hubspotNameOverrides = await this.hubspotNamesMapping();
        let form_id = 'qr-webform';
        let urlParams = new URLSearchParams(window.location.search);
        let quick_reference = urlParams.get('qr_name') ? ' - ' + urlParams.get('qr_name') : '';
        const topic = urlParams.get('qr_name').replace(/-quick-reference$/, '').trim();
        const topicTitle = this.convertToTitle(topic);
        const hsTopic = hubspotNameOverrides[topicTitle] || topicTitle;
        console.log('QR topic: ' + topicTitle)
        console.log('HS topic: ' + hsTopic);

        const data = JSON.stringify({
            'form_id': '33405c70-68c8-4c43-8ee8-0cb6aa2119bd',
            'page_url': window.location.href,
            'page_title': document.title + quick_reference,
            'fields': [
                {
                    'name': 'email',
                    'value': fields.get('email'),
                },
                {
                    'name': 'jobtitle',
                    'value': fields.get('free-job-title'),
                },
                {
                    'name': 'webform_url',
                    'value': window.location.href,
                },
                {
                    'name': 'form',
                    'value': "QR",
                },
                {
                    'name': 'topic',
                    'value': hsTopic,
                }
            ]
        });
        console.log(data)
        if(typeof sendRequestToHubSpotAPI !== 'undefined' && sendRequestToHubSpotAPI) {
            fetchRequestSend(sendRequestToHubSpotAPI, 'POST', data).then(response => {

            })
        }
    }

    /*
    * Sending contact form to hubspot
    * */
    sendContactForm(fields) {
        let form_id = 'contact-form';
        // if fields.get('contact-full-name') is more than 2 words, then it is a full name
        // else it is a first name
        let full_name = fields.get('contact-full-name').split(' ');
        let users = '';

        const data = {
            'form_id': '91696244-a35c-4357-a77c-159efeeae6b4',
            'page_url': window.location.href,
            'page_title': document.title,
            'fields': [
                {
                    'name': 'email',
                    'value': fields.get('contact-email'),
                },
                {
                    'name': 'firstname',
                    'value': full_name[0] ? full_name[0] : fields.get('contact-full-name'),
                },
                {
                    'name': 'lastname',
                    'value': full_name[1] ? fields.get('contact-full-name').replace(full_name[0], '').trim() : '',
                },
                {
                    'name': 'jobtitle',
                    'value': fields.get('contact-job'),
                },
                {
                    'name': 'webform_url',
                    'value': window.location.href,
                },
                {
                    'name': 'form',
                    'value': "Contact Us",
                },
                {
                    'name': 'notes',
                    'value': fields.get('contact-message'),
                }
            ]
        };
        if(typeof sendRequestToHubSpotAPI !== 'undefined' && sendRequestToHubSpotAPI){
            fetchRequestSend(sendRequestToHubSpotAPI, 'POST', data).then(response => {
                console.log(response)
            })
        }
    }
    sendGetQuoteForm(fields) {
        let form_id = 'get-quote';
        // if fields.get('contact-full-name') is more than 2 words, then it is a full name
        // else it is a first name
        let full_name = fields.get('contact-full-name').split(' ');
        let users = '';
        if(fields.get('price-users') == '1 to 24 users'){
            users = '2-4 people';
        }else if(fields.get('price-users') == '25 to 49 users'){
            users = '25-49 people';
        } else if(fields.get('price-users') == '50+ users'){
            users = '50+ people';
        }
        const data = {
            'form_id': '2ec366a8-cda6-422e-8029-fc3ee6934daf',
            'page_url': window.location.href,
            'page_title': document.title,
            'fields': [
                {
                    'name': 'email',
                    'value': fields.get('contact-email'),
                },
                {
                    'name': 'firstname',
                    'value': full_name[0] ? full_name[0] : fields.get('contact-full-name'),
                },
                {
                    'name': 'lastname',
                    'value': full_name[1] ? fields.get('contact-full-name').replace(full_name[0], '').trim() : '',
                },
                {
                    'name': 'jobtitle',
                    'value': fields.get('contact-job'),
                },
                {
                    'name': 'notes',
                    'value': fields.get('contact-message'),
                },
                {
                    'name': 'survey_num_users',
                    'value': users,
                },
                {
                    'name': 'webform_url',
                    'value': window.location.href,
                },
                {
                    'name': 'form',
                    'value': "Quote",
                }
            ]
        };
        if(typeof sendRequestToHubSpotAPI !== 'undefined' && sendRequestToHubSpotAPI){
            fetchRequestSend(sendRequestToHubSpotAPI, 'POST', data).then(response => {
                console.log(response)
            })
        }

    }

    updateLifecycleStage(email, lifecycle){
        let form_id = 'contact-form';
        const data = JSON.stringify({
            'form_id': '91696244-a35c-4357-a77c-159efeeae6b4',
            'page_url': window.location.href,
            'page_title': document.title,
            'fields': [
                {
                    'name': 'email',
                    'value': email,
                },
                {
                    'name': 'lifecyclestage',
                    'value': lifecycle,
                }
            ]
        });
        if(typeof updateLifecycleHubSpotAPI !== 'undefined' && updateLifecycleHubSpotAPI){
            fetchRequestSend(updateLifecycleHubSpotAPI, 'POST', data).then(response => {

            })
        }

    }

    convertToTitle(string) {
        return string
            .split('-') // Split by hyphen
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word (because HS topics case-sensitive)
            .join(' '); // Join words with space
    }

    async hubspotNamesMapping() {
        try {
            const response = await fetch('/files/bd-hubspot-topics-mapping.json');
            if (!response.ok) new Error('Mapping not found!');

            return await response.json();
        } catch (error) {
            console.error(error);
            return {};
        }
    }
}
